import { Component, findComponents } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { ListFilter } from '@swisslife/patterns-base/src/molecules/list-filter/js/list-filter';
import '@swisslife/patterns-base/src/molecules/list-filter/js/list-filter';
import { dispatchCustomEvent, EventNames } from '@swisslife/shared-ui/src/utils/custom-event/js/custom-event';

export interface IItemData {
	$item: JQuery;
	active: boolean;
	category: string;
	subCategory: string;
}
enum States {
	FilterVisible = 'state-o-news-archive--item-visible',
	FilterFade = 'state-o-news-archive--item-fade',
}

enum Selectors {
	NewsItems = 'js-o-news-archive__news-item',
}

const categoryKey = 'archive';

@Component('NewsArchive')
export class NewsArchive extends GondelJqueryComponent {
	private $allItems: JQuery;
	private listFilter: ListFilter;
	private itemData: IItemData[] = [];

	public start() {
		const listFilterComponents = findComponents<ListFilter>(this._ctx, 'ListFilter');
		if (listFilterComponents.length > 0) {
			this.listFilter = listFilterComponents[0];
			this.listFilter.registerCallback(this.listFilterClickCallback);
		}
	}

	public stop() {
		if (this.listFilter) {
			this.listFilter.removeCallback(this.listFilterClickCallback);
		}
	}

	public sync() {
		this.$allItems = this.$ctx.find(`.${Selectors.NewsItems}`);
		this.$allItems.addClass(States.FilterVisible);
		this.$allItems.outerWidth();
		this.$allItems.addClass(States.FilterFade);
		if (this.listFilter) {
			this.gatherItemData(this.$allItems);
			this.setInitialSubCategory();
		}
	}

	private gatherItemData($allItems: JQuery) {
		$allItems.each((index, item) => {
			const $item = $(item);

			const itemData: IItemData = {
				$item,
				active: true,
				category: $item.data('category-key') || '',
				subCategory: $item.data('subcategory-key').toString() || '',
			};

			this.itemData.push(itemData);
		});
	}

	private setInitialSubCategory() {
		const initialSubCategory = this.$ctx.data('initial-subcategory').toString();
		this.listFilter.setFilterState(categoryKey, [initialSubCategory]);
		this.filterItems(initialSubCategory);
		this.updateItemsState();
	}

	private filterItems(selectedSubCategory: string) {
		$.each(this.itemData, (_, itemData) => {
			if (itemData.subCategory === selectedSubCategory) {
				itemData.active = true;
			} else {
				itemData.active = false;
			}
		});
	}

	private updateItemsState() {
		this.$allItems.removeClass(States.FilterVisible);
		this.$allItems.removeClass(States.FilterFade);
		// needed so that animation of elements work, which where visible and stay visible after filtering
		this.$allItems.outerWidth();
		for (const itemData of this.itemData) {
			if (itemData.active) {
				itemData.$item.addClass(States.FilterVisible);
				itemData.$item.outerWidth();
				itemData.$item.addClass(States.FilterFade);
			}
		}
	}

	private listFilterClickCallback = (_: string, filterItem: { itemKey: string; itemName: string }) => {
		const selectedSubCategory = filterItem.itemName.trim();
		this.filterItems(selectedSubCategory);
		this.updateItemsState();
		dispatchCustomEvent(this.$ctx, EventNames.FilterClick, {
			filterCategory: 'category',
			filterName: filterItem.itemName.trim(),
			filterID: filterItem.itemKey,
		});
	};
}
